module.exports = __webpack_public_path__ + "img/bg-login.0ff83b41.jpg";